import { v4 as uuid } from 'uuid';

export function shortUUID() {
    return uuid().replace(/-/g, '');
}